module.exports = require("core-js/modules/es.global-this.js");